var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"px-2 py-6 text-center"},[_c('i',{staticClass:"fal fa-10x fa-frown text-gray-light pt-10"}),_c('div',{staticClass:"text-xl py-6 text-gray"},[_vm._v("Désolé, aucune donnée à afficher pour l'instant")])])
}
var staticRenderFns = []

export { render, staticRenderFns }